const getDetailPageLink = (id: number, route: string) => {
    return `/${route}/${id}`;
};
export default getDetailPageLink;
